import { ImageField } from '@sitecore-jss/sitecore-jss-nextjs';
import { Image } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';

import tailwindConfig from '@gn-audio/jss-components/tailwind-presets/jabra-preset';
export type ResponsiveImageProps = {
  desktopImage: ImageField;
  mobileImage: ImageField;
  tabletImage?: ImageField;
  rounded?: boolean;
};
const tailwindBreakpoints = tailwindConfig?.theme?.screens;

export const ResponsiveImage = ({
  desktopImage,
  mobileImage,
  tabletImage,
  rounded,
}: ResponsiveImageProps) => {
  const mobileBreakpoint = tailwindBreakpoints?.xxs || '480px';
  const tabletBreakpoint = tailwindBreakpoints?.md || '768px';
  const desktopBreakpoint = tailwindBreakpoints?.lg || '1024px';

  return (
    <picture className={classNames('overflow-hidden', rounded && 'rounded-full')}>
      {tabletImage ? (
        <>
          {/* Source for desktop images when tablet is present */}
          <source media={`(min-width: ${desktopBreakpoint})`} srcSet={desktopImage?.value?.src} />
          {/* Source for tablet images */}
          <source media={`(min-width: ${tabletBreakpoint})`} srcSet={tabletImage?.value?.src} />
        </>
      ) : (
        // Source for desktop images when tablet is not present
        <source media={`(min-width: ${mobileBreakpoint})`} srcSet={desktopImage?.value?.src} />
      )}
      {/* Source for mobile images */}
      <source
        media={`(max-width: ${parseInt(mobileBreakpoint) - 1}px)`}
        srcSet={mobileImage?.value?.src}
      />
      <Image className={classNames(rounded && 'rounded-full')} field={desktopImage} />
    </picture>
  );
};
